module.exports = __webpack_public_path__ + "static/media/filter.cc833d90.svg";